import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import find from "lodash/find";
import moment from "moment";
import sortBy from "lodash/sortBy";
import { connect } from "react-redux";
import {
  Card,
  Button,
  CardTitle,
  CardText,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import { deepClone } from "../../../../../utils/copyObject";
import Loading from "../../../../../hoc/Loading/Loading";
import axios from "../../../../../axios";
import * as actionCreators from "../../../../../modules/actions/index";
import { ensureMappings } from "../../../../../utils/ensureMappings";
import {
  kpiBasedType,
  chartLineColor,
  plotlyMarkerTypes,
  benchmarkLineTypes,
  dtickFormat,
  dashboardChartSize,
  returnHierarchyGroup,
  KPISbyMonth,
  chartMarkerSymbolsVariation,
  chartMarkerSymbols,
  checkUserPrivileges,
  chart_legend_position,
  chartParams,
  checkNoDataLayoutValidity,
  getEmptyGraphLayoutObject,
  mergeLayoutAnnotations,
  getAvgTenureFormatted
} from "../../../../../utils/constants";
import {
  getGenderLists,
  createKPIAgreegateRequestDataRefreshChart,
  getAllOccupationAndSeniorityValues,
} from "../../../../../utils/filterKpisData";
import { chartKpiDataFieldRefTransformationSingleChart, generateLegendTitle } from "../../../../../utils/chartUtils";
import ChartEmptyState from "../../../Components/ChartEmptyState/ChartEmptyState";
import Plot from "../../../../../utils/customPlotly";
import ManualEntryModal from "../../../ChartList/ManualEntryModal";
import * as url from "../../../../../utils/url";
import Spinner from "../../../../../assets/spinner.gif";
import ChartAverageTable from "../../../ViewChart/ChartAverageTable";

class DashboardChartPlot extends Component {
  chartMenuRef = React.createRef();
  chartMenuBtnRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      chart: null,
      random: "",
      isUpdateData: false,
      isLoading: false,
      dashboardChartMenu: false,
      rangeInit: [],
      showViewChart: false,
      clickedPoint: null,
      isChartNotesDisplay: false,
      showManualEntryAnswersModal: false,
      plotlyData: null,
      dropdownOpen: false,
      dropdownFilter: false,
      dashboardDateUpdate: null,
      lockedChartUpdating:false,
      annotations:[]
    };
  }

  componentDidMount() {
    console.log("MOUNTED",chart && chart.name)
    let { chart } = this.props;
    // console.log('chart: ', chart)
    if (chart && chart._id && chart.kpiData && chart.kpiData.length > 0) {
      let { startDate, endDate } = chart;
      let res = this.processKpiData(chart, { startDate, endDate });
      this.setState({
        // chart:{...res}
        chart: deepClone(res),
      });
    }
    document.addEventListener("mousedown", this.handleDbClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleDbClickOutside);
  }

  handleDbClickOutside = event => {
    //  console.log('event.target: ', event.target)
    let chartMenu =
      this.chartMenuRef &&
      this.chartMenuRef.current &&
      !this.chartMenuRef.current.contains(event.target);
    let chartMenuBtn =
      this.chartMenuBtnRef &&
      this.chartMenuBtnRef.current &&
      !this.chartMenuBtnRef.current.contains(event.target);

    if (chartMenu) {
      if (chartMenuBtn && chartMenu) {
        this.closeFilterMenu();
      }
    }
  };

  closeFilterMenu = () => {
    this.setState(prevState => ({ dropdownFilter: false }));
  };

  shouldComponentUpdate(nextProps, nextState) {
    
    let { reports } = this.props;
    let { chart } = this.props;

    let newReportDate =
      nextProps.reports.dashboardDateUpdate != null
        ? nextProps.reports.dashboardDateUpdate
        : reports.dashboardDateUpdate;
    // let{isUpdateData}= nextState
    // let chartDate = chart && chart.dashboardDateUpdate? chart.dashboardDateUpdate:null
    // let nextChartDate = nextProps.chart && nextProps.chart.dashboardDateUpdate? nextProps.chart.dashboardDateUpdate:null

    // console.log(this.state, '--------isUpdateData--------', nextState)
    // console.log('nextProps: ', nextProps)

    if(this.state.lockedChartUpdating){
      return false
    }

    if(this.state.isLoading){
      return false
    }

    if (this.state.isUpdateData) {
      return false;
    }

    if (nextProps.chart.col_size != this.props.chart.col_size) {
      return true;
    }

    // set dashboardDate at top, then chart dateat bottom and check state against one another

    if (
      this.state.dashboardDateUpdate != null &&
      newReportDate != null &&
      // && (new Date(nextState.chart.dashboardDateUpdate).getTime() == new Date(dashboardDateUpdate).getTime())
      moment(newReportDate).isSame(moment(this.state.dashboardDateUpdate))
    ) {
      console.log('NON-2-STOP')
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    let { reports, chart } = this.props;
    let cRepDate = new Date(reports.dashboardDateUpdate).getTime();
    let oldDashboardDate = new Date(
      prevProps.reports.dashboardDateUpdate
    ).getTime();
    let { dashboardDateUpdate } = this.state;
    // if(chart && chart.isRemoveFlag && chart!=null && prevProps.chart.isRemoveFlag!=chart.isRemoveFlag){
    //   this.setState({chart:null})
    // }
    if (
      chart &&
      reports &&
      reports.dashboardDateUpdate != null &&
      oldDashboardDate != cRepDate
    ) {
      let chartDbDate = new Date(chart.dashboardDateUpdate).getTime();

      // console.log('chartDbDate: ', chartDbDate)
      // console.log('cRepDate: ', cRepDate)
      // console.log('')
      // && dashboardDateUpdate!= cRepDate

      if (chartDbDate != cRepDate) {
        // console.log('update!')
        this.refreshChart(reports.dashboardDateUpdate);
      }
    }
  }

  refreshChart = async dashboardDateUpdate => {
    let { chart } = this.state
    let { kpiType, kpiData, selectedOffice } = chart
    let chartId = chart._id;


  if(!chart.lockedDate){

    this.setState({ isLoading: true, isUpdateData: true });

    let { mappingMaster, user, reports } = this.props,
      { startDate, endDate } = reports;

    let organizationId = user.profile.organizationId;
    let { staticHierarchy } = organizationId;

    // Mappings may not be in redux yet when landing directly on the dashboard
    // (nothing on this page fetched them). Wait for them before building the
    // refresh request — never refresh with empty mappings.
    let mappingMasterList;
    try {
      mappingMasterList = await ensureMappings(
        organizationId,
        mappingMaster.mappingMasterList,
        this.props.onMappingMasterListFetched
      );
    } catch (error) {
      console.log("error fetching mapping master list: ", error);
      this.setState({ isLoading: false, isUpdateData: false });
      return;
    }

    let that = this,
      dateRange = { startDate, endDate },
      results = {};

    let {
      allOccupationValues,
      allSeniorityValues,
    } = getAllOccupationAndSeniorityValues(mappingMasterList);

    let KRD = kpiData.map(kpi => {
      if (kpiType === kpiBasedType.empDataBased) {
        return createKPIAgreegateRequestDataRefreshChart(
          kpi,
          mappingMasterList,
          allOccupationValues,
          allSeniorityValues
        );
      } else if (kpiType === kpiBasedType.surveyBased) {
        return { code: kpi.kpiId.code };
      }
    });

    let orgMapping = mappingMasterList;
    let genderMapping = getGenderLists(orgMapping);
    let chartStartDate = startDate ?
      moment.utc(startDate).format("YYYY-MM-DD") + "T00:00:00.000Z" : null
    let chartEndDate = endDate ?
      moment.utc(endDate).format("YYYY-MM-DD") + "T23:59:59.000Z" : null

    results = { kpiList: KRD, ...genderMapping, kpiType };

    if (selectedOffice && selectedOffice.value) {
      if (chart && chart.kpiType != "SURVEY_BASED") {
        results["allOfficeKeys"] = returnHierarchyGroup(
          staticHierarchy,
          selectedOffice.value
        );
      }
      results["officeKey"] = selectedOffice.value;
      results["missingSelectedOffice"] = false;
    } else {
      let nameArr = chart.officeId.officeHierarchyPath.split("#");
      let name = nameArr[nameArr.length - 1];
      let office = staticHierarchy.filter(e => e.id === name)[0];
      if (chart && chart.kpiType != "SURVEY_BASED") {
        results["allOfficeKeys"] = returnHierarchyGroup(
          staticHierarchy,
          office.officeKey
        );
      }
      results["officeKey"] = office.officeKey;
      results["missingSelectedOffice"] = true;
      results["officeData"] = office;
    }
    results["_id"] = chartId;
    results["isUpdate"] = { status: true, chart: true };

    results["startDate"] = chartStartDate;
    results["endDate"] = chartEndDate;

    results["filters"] = {
      _id: chart._id,
      dashboardId: this.props.reports._id,
    };
    results["dashboardUpdate"] = dateRange;

    if (this.props.reports.startDate) {
      results["old_date_range"] = {
        startDate: this.props.reports.startDate,
        endDate: this.props.reports.endDate,
      };
    } else {
      results["old_date_range"] = null;
    }

    results["dashboardDateUpdate"] = dashboardDateUpdate;
    let newReportDate = this.props.reports.dashboardDateUpdate;

    console.log("updattttingggg")

   
      axios
      .post(url.updateDashboardChartsData(chart._id), results)
      .then(({ data }) => {
        that.setState({ isUpdateData: false });

        let result = data.data.chart;
        let updatedChart = this.processKpiData(result, { startDate, endDate });
        updatedChart = { ...updatedChart, dashboardDateUpdate: newReportDate };

        that.setState({ isLoading: false, chart: { ...updatedChart } });

        // that.setState({ dashboardDateUpdate: newReportDate })

        // console.log('NEW CHART-----')

        that.setState({ dashboardDateUpdate });

        that.props.updateReportCharts(updatedChart);
      })
      .catch(error => {
        console.log("err--", error);
        // reset loading flags so a failed refresh doesn't freeze the chart
        that.setState({ isLoading: false, isUpdateData: false });
      })
      .finally(() => {
        let { chart } = that.state;
        // that.setState({isLoading:false})
        console.log(`chart done: ${chart.name}`);
      });
  }else{
    this.setState({lockedChartUpdating:true})
  }
   
  };

  renderFilterDropdown = () => {
    let { chart } = this.props;
    let { user, currentDashboard } = this.props;
    let isEdit = checkUserPrivileges(user.profile, currentDashboard);
    if (chart) {
      return (
        <Dropdown
          isOpen={this.state.dashboardChartMenu}
          toggle={() => {
            this.setState({
              dashboardChartMenu: !this.state.dashboardChartMenu,
            });
          }}
          style={{ float: "right" }}
        >
          <DropdownToggle
            className="chart-item-menu"
            tag="span"
            data-toggle="dropdown"
            aria-expanded={this.state.dashboardChartMenu}
          >
            <i
              className="chart-item-menu flaticon-menu-1"
              style={{ cursor: "pointer" }}
            ></i>
          </DropdownToggle>
          <DropdownMenu className="dbChartMenuOptions" style={{ padding: "0" }}>
            <DropdownItem
              className="dbChartViewModal"
              onClick={() => this.navigateToChart(chart)}
            >
              {" "}
              <i className="flaticon-vision" /> View Chart
            </DropdownItem>
            {checkUserPrivileges(user.profile, currentDashboard) ? (
              <DropdownItem
                className="dbChartRemove"
                onClick={() => this.removeChart(chart)}
              >
                <i className="flaticon-trash" /> Remove
              </DropdownItem>
            ) : null}
          </DropdownMenu>
        </Dropdown>
      );
    } else {
      return null;
    }
  };

  chartLineMarkerGenerator = (color, type,length) => {
    let obj;

    if (type === "line") {
      obj = {
        color,
        width: 1,
      };
    } else {
      let marker = Math.floor(Math.random() * 9);
      let variation = Math.floor(Math.random() * 3);
      let symbol = `${chartMarkerSymbols[marker]}${chartMarkerSymbolsVariation[variation]}`;
      obj = {
        color: [...Array(length).fill(color)],
        size: 10,
        symbol,
      };
    }
    return obj;
  };

  kpiGoalValue = (chart, kpi, index) => {
    if (chart && chart.goals && chart.goals.length > 0) {
      if (kpi && kpi.kpiId && kpi.kpiId._id) {
        let result = chart.goals.filter(
          e =>
            e.kpiId === kpi.kpiId._id &&
            parseInt(e.name.match(/\d+/)[0]) === index + 1
        );
        if (result && result.length > 0) {
          return result[0];
        }
      }
    }
    return {};
  };

  handleChartPointClick = a => {
    let { chart } = this.state;
    if (chart && chart.name && chart.kpiType) {
      let { kpiType } = chart;
      if (kpiType === kpiBasedType.surveyBased) {
        this.setState({
          showManualEntryAnswersModal: true,
          clickedPoint: a,
        });
      }
    }

    const annotations_old = [...this.state.annotations];
    const getAvgTenureIfAvailable=(pointData,pointIndex)=>{
      if(pointData && pointIndex>=0){
        if(pointData.data && pointData.data.text && pointData.data.text.length){
          for (const str of pointData.data.text[pointIndex]) {
            if(str.indexOf("Avg Tenure")>=0){
              return ", "+str;
            }
          }
        }
      }
      return "";
    }


    if (a.points && a.points[0] && a.points[0].data) {
      const pointIndex = a.points[0].pointIndex;
      const curveIndex = a.points[0].curveNumber;
      const pointData = a.points[0];
      let annotate_text = `${pointData.text[0]}, ${Math.round(pointData.y *
        100)}% ${getAvgTenureIfAvailable(pointData,pointIndex)}`;

      let annotation = {
        text: annotate_text,
        x: pointData.x,
        y: parseFloat(pointData.y.toFixed(2)),
        borderwidth:1,
        clicktoshow:"onoff"
      };

      annotations_old.push(annotation);

      this.setState({ annotations: annotations_old });

     
        this.updateChartPointers(
  
          pointIndex,
          curveIndex
        );
      
    }
  };

  handleChartPointDoubleClick = (a) => {
    this.setState({ annotations: [] });
      this.resetChartPointers();
    
  };
  openChartMenu = () => {
    this.setState(prevState => ({
      dropdownFilter: !prevState.dropdownFilter,
    }));
  };

  onPlotlyUpdate = plot => {
    let { chart } = this.state;

    if (chart && chart._id) {
      let { rangeInit } = this.state;
      if (plot && plot.layout && plot.layout.xaxis) {
        let { range } = plot.layout.xaxis;
        if (
          rangeInit &&
          rangeInit != null &&
          rangeInit.length > 1 &&
          range &&
          range.length > 1
        ) {
          let plotlyDTick = dtickFormat(range[0], range[1]);
          let pTick2 = dtickFormat(rangeInit[0], rangeInit[1]);
          if (pTick2 != plotlyDTick) {
            this.setState({ rangeInit: range, plotlyDTick });
          }
        } else {
          this.setState({ rangeInit: range });
        }
      }
    }
  };

  renderPlot = () => {
    let { chart, isLoading } = this.state;

    let { profile } = this.props.user,
      { staticHierarchy } = profile.organizationId;
    let {
        name,
        yAxisFormat,
        dtickFormat,
        benchmarkArray,
        kpiForPlotly,
        yRange,
      } = chart;

    let yTickFormat,
      plotlyData = [];
    // no layout here because chart empty
    if (chart && !chart.layout) {
      if (yAxisFormat === "Absolute") {
        yTickFormat = ".3%";
      } else {
        yTickFormat = "";
      }

      plotlyData.concat(benchmarkArray);
      if (kpiForPlotly) {
        plotlyData = plotlyData.concat(kpiForPlotly);
      }

      let plotlyKpiData = plotlyData.filter(
        data =>
          data.name !== "Benchmark for KPI" &&
          data.x.length > 0 &&
          data.y.length > 0
      );

      let plotlyBenchMarkData = plotlyData.filter(
        data => data.name === "Benchmark for KPI"
      );
      let combinedPlotlyData = [...plotlyKpiData, ...plotlyBenchMarkData];

      let tickvalsString = null;
      if (combinedPlotlyData.length === 1) {
        if (combinedPlotlyData[0].x.length === 1) {
          tickvalsString = [combinedPlotlyData[0].x[0]];
        }
      }

      if (combinedPlotlyData.length > 1) {
        let tickvalsList = combinedPlotlyData.map(data => {
          let xvalues = data.x;
          return xvalues;
        });
        let filteredTickvalsList = tickvalsList.filter(
          tickValue => tickValue.length === 1
        );
        if (
          tickvalsString == null &&
          tickvalsList.length > 0 &&
          tickvalsList.length === filteredTickvalsList.length
        ) {
          let firstTickVal = filteredTickvalsList[0][0];
          let filterTickVal = filteredTickvalsList.filter(tickVal =>
            moment(tickVal[0]).isSame(firstTickVal, "month")
          );
          if (filterTickVal.length === filteredTickvalsList.length) {
            tickvalsString = [firstTickVal];
          }
        }
      }

      let selectorOptions = {
        buttons: [
          {
            step: "month",
            stepmode: "backward",
            count: 4,
            label: "last 3m",
          },
          {
            step: "month",
            stepmode: "backward",
            count: 7,
            label: "6m",
          },
          {
            step: "year",
            stepmode: "backward",
            count: 1,
            label: "1y",
          },
          {
            step: "all",
          },
        ],
        // activecolor
      };
    }

    console.log('mps---------', chart.kpiData.length)


    return (
      <span className="plotly-dashboard-svg-custom-height">
        {isLoading ? (
          <div className="dashboardChartLoaderContainer">
            <img src={Spinner} className="dashboardChartLoader" />
          </div>
        ) : null}
        {chart && chart.layout ? (
          <ChartEmptyState />
        ) : (
        <Plot
          data={plotlyData}
          layout={
            
            chart.layout
              ? { ...chart.layout,   
                annotations: mergeLayoutAnnotations(chart.layout, this.state.annotations),
                 rangeselector: chartParams(chart,'rangeB'),
                 modebar:{orientation:'v'},
                }
              : {
                  responsive: true,
                  showlegend: true,
                  autosize: true,
                  pull: [0.8, 0, 0],
                  uirevision: true,
                  legend: chartParams(chart,'legend','rangeB'),
                  paper_bgcolor: "white",
                  plot_bgcolor: "#e5ecf694",
                  margin: chartParams(chart, 'margin','rangeB'), 
                  xaxis:  chartParams({...chart, dtickFormat, plotlyDTick: dtickFormat}, 'xaxis','rangeB'),
                  yaxis: chartParams({...chart,dtickFormat,plotlyDTick: dtickFormat, yRange}, 'yaxis','rangeB'),
                  hovermode: "closest",
                  annotations:this.state.annotations,
                  modebar:{orientation:'v'},
                  rangeselector: chartParams(chart,'rangeB'),
                }
          }
          scrollZoom={true}
          config={
            !chart.layout
              ?  chartParams(chart, 'config', 'rangeB')
              : { displaylogo: false, responsive: true, scrollZoom: true }
          }
          className={`${
            isLoading ? "opacity40" : ""
          } recentActivity plotlyChart dashboardCreatePlotlyChart`}
          onUpdate={figure => this.onPlotlyUpdate(figure)}
          onClick={this.handleChartPointClick}
          onDoubleClick={this.handleChartPointDoubleClick}
          useResizeHandler={true}
          style={{ width: "100%", height: "100%" }}
        />
        )}

        <div>
          <div className="">
            <ChartAverageTable
              kpiForPlotly={chart.kpiForPlotly}
              yAxisFormat={chart.yAxisFormat}
              isPopup={true}
              chartSelector={"_id" + chart._id}
              chart={chart}
            />
          </div>
        </div>
      </span>
    );
  };

  removeChart = item => {
    let { reports } = this.props;

    let results = {
      filters: {
        _id: item._id,
        dashboardId: reports._id,
      },
      chartRef: item.chartId,
      dateRange: { startDate: item.startDate, endDate: item.endDate },
      name: item.name,
      chart: { ...item },
      // updateAttr: {
      //   isArchive:isArchive
      // }
    };

    item = { ...item, isRemoveFlag: true };
    let that = this;
    that.props.updateReportCharts(item);

    axios
      .post(url.archiveDashboardChart, results)
      .then(response => {
        let dashboard = response.data.data;
        delete dashboard.createdBy;

        that.props.updateReport(dashboard);
      })
      .catch(error => {
        console.log("err--", error);
      });
  };

  toggleTaskView = () => {
    // console.log('change state')
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  changeChartSize = size => {
    let { chart } = this.state;
    let { reports } = this.props;

  
      let results = {
        chartId: chart._id,
        dashboardId: reports._id,
        updateAttr: {
          col_size: size,
        },
      };
      chart = { ...chart, col_size: size };
      // let that=this
      this.setState({ chart });
      this.props.updateReportCharts(chart);
      this.props.changeSize(chart);
  
      axios
        .post(url.updateDashboardChart, results)
        .then(response => {})
        .catch(error => {
          console.log("err--", error);
        });
    

   
  };

  navigateToChart = value => {
    if (value == "isChartNotesDisplay") {
      this.setState({ showViewChart: true, isChartNotesDisplay: true });
    } else {
      this.setState({ showViewChart: true });
    }
  };

  closeViewChartModal = () => {
    this.setState({ showViewChart: false });
  };

  renderNewChartAlert = () => {
    let { chart } = this.state,
      { reports } = this.props;
    let dbDate =
      moment(chart.dashboardDate) > moment(reports.dashboardDateUpdate);
    let dbUpdate =
      chart.dashboardDateUpdate == null ||
      moment(chart.dashboardDateUpdate) != moment(reports.dashboardDateUpdate);
    if (dbDate && dbUpdate) {
      return (
        <div className="dashboardNewChartContainer">
          <span className="dashboardNewChartAlert">New chart</span> as of{" "}
          {moment(chart.dashboardDate).format("MMM Do, YYYY")}
        </div>
      );
    }
  };

  updateChartPointers = (pointIndex, curveIndex) => {
    let currentChartObject = { ...this.state.chart };

    const kpiForPlotlyArray = currentChartObject.kpiForPlotly
      ? [...currentChartObject.kpiForPlotly]
      : [];

    let kpiForPlotlyObject = kpiForPlotlyArray[curveIndex];

    if (kpiForPlotlyObject) {
      const marker = kpiForPlotlyObject.marker;

      // marker.color = "rgb(255,0,0)"

      if (marker) {
        const new_color = marker.color;

        new_color[pointIndex] = "rgb(255,0,0)";

        marker.color = deepClone(new_color);

        kpiForPlotlyObject = {
          ...kpiForPlotlyObject,
          marker,
        };

        kpiForPlotlyArray[curveIndex] = kpiForPlotlyObject;

        currentChartObject = {
          ...currentChartObject,
          kpiForPlotly: [...kpiForPlotlyArray],
        };

        this.setState({ chart: currentChartObject });
      }
    }
  };

  resetChartPointers = () => {
    const { chart } = this.state;

    const newCharts = {
      ...chart,
      kpiForPlotly: chart.kpiForPlotly.map((kpi, idx) => ({
        ...kpi,
        marker: {
          ...kpi.marker,
          color:
            kpi.x && kpi.x.length && kpi.line
              ? [...Array(kpi.x.length).fill(kpi.line.color)]
              : chartLineColor(idx),
        },
      })),
    };

    this.setState({ chart: newCharts });
  };

  processKpiData = (chart, selectedDates) => {
    chart = chartKpiDataFieldRefTransformationSingleChart(chart)
    const { profile } = this.props.user;
    let max = 1,
      yRange,
      min = 0,
      y,
      layout,
      yPercent,
      xMaxDate,
      xMinDate,
      dtickFormatVal,
      yAxisFormat = chart.yAxisFormat,
      templateType;

    const kpi = chart.kpiData.map((kpi, index) => {
      let goalValue = this.kpiGoalValue(chart, kpi, index);

      const sortedKpiAggregate = sortBy(kpi.score, (kpi, i) => kpi.date);
      let text,
        description,
        chartColor,
        x,
        y,
        length,
        annotations,
        xaxis,
        yaxis,
        yAlt,
        kpiCount = index + 1;

      //if (sortedKpiAggregate.length != 0) {
      // console.log("sorted exists -----", chart._id);

      let avgTenure = false
      text = sortedKpiAggregate.map(val => {
        let value_floor = Math.round(val.value);
        avgTenure = val && val.avgTenure ? val.avgTenure : false
        let textString = [];
        let ts;
        let ethnicity = val.numeratorEthnicity ? val.numeratorEthnicity : "";
        let kpiCode = kpi.kpiId.code;

        if (KPISbyMonth.indexOf(kpiCode) > -1) {
          let t = moment.utc(val.date).format("MMMM YYYY");
          textString.push(t);
        } else {
          let t = moment.utc(val.date).format("MMMM D, YYYY");
          textString.push(t);
        }

        if (
          !val.numeratorCount ||
          val.numeratorCount === undefined ||
          typeof val.numeratorCount == "undefined"
        ) {
          val.numeratorCount = 0;
        }
        if (val && val.numeratorType && val.totalEmployees) {
          if (kpi.kpiId.code === "COMP-1" || kpi.kpiId.code === "COMP-2") {
            ts = ethnicity
              ? `${ethnicity} ${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, male count: ${
                  val.totalEmployees
                    ? val.totalEmployees - val.numeratorCount
                    : null
                }`
              : `${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, male count: ${
                  val.totalEmployees
                    ? val.totalEmployees - val.numeratorCount
                    : null
                }`;
            textString.push(ts);
          } else {
            ts = ethnicity
              ? `${ethnicity} ${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, total: ${val.totalEmployees ? val.totalEmployees : null}`
              : `${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, total: ${val.totalEmployees ? val.totalEmployees : null}`;
            textString.push(ts);
          }
        } else if (val && val.numeratorType && !val.totalEmployees) {
          ts = ethnicity
            ? `${ethnicity} ${val.numeratorType
                .substring(1)
                .replace(/-/g, ", ")
                .toLowerCase()} count: ${val.numeratorCount}${
                yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
              }`
            : `${val.numeratorType
                .substring(1)
                .replace(/-/g, ", ")
                .toLowerCase()} count: ${val.numeratorCount}${
                yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
              }`;
          textString.push(ts);
        } else if (val.totalEmployees && !val.numeratorType) {
          ts = `of total: ${val.totalEmployees ? val.totalEmployees : null}`;
          textString.push(ts);
        } else {
          textString.push("");
        }

        let goalText = "";
        if (goalValue && goalValue.number) {
          let diff = parseInt(goalValue.number) - Math.round(val.value);
          let res = Math.round(diff);
          if (res > 0) {
            goalText = `Until Goal met: ${res}%`;
            textString.push(goalText);
          } else {
            goalText = `Goal reached 😀👍!`;
            textString.push(goalText);
          }
        } else {
          goalText = "";
          textString.push(goalText);
        }

        if(val.avgTenure >= 0 && val.avgTenure != null){
          const tenureString = `Avg Tenure: ${getAvgTenureFormatted(val.avgTenure)}`
          console.log({textString})
          if(textString[2]==""){
            textString[2] = tenureString
            textString[3] = ""
          }
          else{
            textString.push(tenureString)
          }
        }else{
          textString.push("")
        }
        return textString;
      });

      if (yAxisFormat === "Absolute") {
        y = sortedKpiAggregate.map(kpi => kpi.numeratorCount);
        yAlt = sortedKpiAggregate.map(kpi => Math.round(kpi.value) / 100);
      } else {
        y = sortedKpiAggregate.map(kpi => Math.round(kpi.value) / 100);
        yAlt = sortedKpiAggregate.map(kpi => kpi.numeratorCount);
      }

      description = generateLegendTitle(
        kpi,
        kpi.kpiId.description,
        index,
        false,
        "",
        ""
      );

      sortedKpiAggregate.map(kpi => {
        let yVal;
        if (yAxisFormat === "Absolute") {
          yVal =
            kpi.data.totalEmployees !== undefined
              ? kpi.data.totalEmployees
              : kpi.totalEmployees;
        } else {
          yVal = kpi.value / 100;
        }
        if (yVal > max) {
          max = yVal;
        }
      });

      if (yAxisFormat == "Absolute") {
        yRange = [-0.05, max + 100];
        yAxisFormat = "Absolute";
        templateType =
          "<b>%{text[0]}</b>, " +
          `<b>%{y:.0}</b> (KPI ${kpiCount}) <br>` +
          "%{text[1]}<br>" +
          "%{text[2]}<br>" +
          "%{text[3]}<br>" +
          "<extra></extra>";
      } else {
        yRange = [-0.05, max + 0.03];
        yAxisFormat = "";
        templateType =
          "<b>%{text[0]}</b>, " +
          `<b>%{y:.0%}</b> (KPI ${kpiCount}) <br>` +
          "%{text[1]}<br>" +
          "%{text[2]}<br>" +
          "%{text[3]}<br>" +
          "<extra></extra>";
      }
      chartColor = chartLineColor(index);

      x = sortedKpiAggregate.map(kpi => {
        let date1 = moment.utc(kpi.date).format("YYYY-MM-DD");
        if (xMinDate == undefined || xMinDate > date1) {
          xMinDate = date1;
        }

        if (xMaxDate == undefined || date1 > xMaxDate) {
          xMaxDate = date1;
        }
        return kpi.date;
      });
      length = x.length;
      dtickFormatVal = dtickFormat(xMinDate, xMaxDate, length);
      annotations = [];
      xaxis = "y";
      yaxis = "x";
      // layout = {
      //   showlegend: true,
      //   autosize: true,
      //   uirevision: true,
      //   legend: {
      //     bgcolor: "white",
      //     // xanchor: "left",
      //     orientation: "h",
      //     y: legendPosition(plotlyData.length),
      //     x: -0.05,
      //   },
      //   paper_bgcolor: "#F3F3F4",
      //   plot_bgcolor: "#F3F3F4",
      //   margin: {
      //     l: 90,
      //     r: 60,
      //     b: 90,
      //     t: 40,
      //     pad: 0,
      //   },
      //   xaxis: {
      //     showgrid: true,
      //     type: "date",
      //     automargin: true,
      //     // tickformat:'%b %Y',
      //     // dtick: "M1" ,
      //     title: {
      //       text:
      //         moment(chart.xMinDate).format("YYYY") ===
      //         moment(chart.xMaxDate).format("YYYY")
      //           ? `Date (${moment(chart.xMinDate).format("YYYY")})`
      //           : "Date",
      //       standoff: 20,
      //     },
      //     dtick: plotlyDTick,
      //     tickformat:
      //       typeof plotlyDTick != "number" ? "%b<br>%Y" : "%b %e",
      //     tick0: chart.xMinDate,
      //     rangeselector: selectorOptions,
      //     // range: [
      //     //   new Date(chart.xMinDate).getTime(),
      //     //   new Date(chart.xMaxDate).getTime()
      //     // ] ,
      //     tickfont: { color: "#313236" },
      //   },
      //   yaxis: {
      //     showgrid: true,
      //     zerolinecolor: "#ffffff",
      //     zerolinewidth: 1,
      //     gridcolor: "#ffffff",
      //     gridwidth: 2,
      //     tickformat:
      //       chart.yAxisFormat && chart.yAxisFormat == "Absolute"
      //         ? undefined
      //         : "%",
      //     // .3%', '.0%',
      //     tickfont: { color: "#313236" },
      //     title: {
      //       text:
      //         chart.yAxisFormat && chart.yAxisFormat == "Absolute"
      //           ? `Absolute`
      //           : "Percent",
      //       standoff: 20,
      //     },
      //     // title:{standoff:20},
      //     range: this.props.yRange,
      //     scrollZoom: true,
      //     // rangemode: 'tozero',
      //     // fixedrange:true,
      //     automargin: true,
      //   },
      //   // hovermode:'x',
      //   hovermode: "closest",
      // };
      //} else {
      //  console.log("data no sorted ---- ", chart._id);
      //  let dashboardEndDate = this.props.reports.endDate;
      //  let endPlotlyDate = chart.endDate
      //    ? moment(chart.endDate).format("YYYY-MM-DD")
      //    : dashboardEndDate
      //    ? moment(dashboardEndDate).format("YYYY-MM-DD")
      //    : selectedDates.endDate
      //    ? moment(selectedDates.endDate).format("YYYY-MM-DD")
      //    : moment().format("YYYY-MM-DD");
      //  let startPlotlyDate = chart.startDate
      //    ? moment(chart.startDate).format("YYYY-MM-DD")
      //    : moment(selectedDates.startDate).format("YYYY-MM-DD");
      //  layout = {
      //    yaxis: {
      //      visible: false,
      //    },
      //    autosize: true,
      //    paper_bgcolor: "#F3F3F4",
      //    plot_bgcolor: "#F3F3F4",
      //    annotations: [
      //      {
      //        text: "No matching data found",
      //        xref: "paper",
      //        yref: "paper",
      //        showarrow: false,
      //        font: {
      //          size: 20,
      //          //  "color": "red"
      //        },
      //      },
      //    ],
      //    margin: {
      //      //  t: 10,
      //      //  l: 30,
      //      //  r: 30,
      //      t: 0,
      //      b: 60,
      //    },

      //    xaxis: {
      //      type: "date",
      //      //  autorange: true,
      //      //  fixedrange: true,
      //      dtick: dtickFormat(startPlotlyDate, endPlotlyDate),
      //      range: [startPlotlyDate, endPlotlyDate],
      //      showgrid: false,
      //    },

      //    hovermode: "closest",
      //    showlegend: false,
      //  };
      //}

      return {
        name: `${description}`,
        description,
        y,
        x,
        yAlt,
        text,
        hovertemplate: templateType,
        type: "scatter",
        line: this.chartLineMarkerGenerator(chartColor, "line"),
        marker: this.chartLineMarkerGenerator(chartColor, "marker",x.length),
        xaxis,
        yaxis,
        id: kpi.kpiId._id,
        lines: "scatter",
        mode: length > 12 ? "lines" : "lines+markers",
        annotations,
        // ...result
      };
    });

    let benchmark = {};
    if (chart.benchmarkData) {
      let { industriesList } = this.state;
      let industry = find(industriesList, {
        _id: profile.organizationId.industry,
      });
      let { score } = chart.benchmarkData;
      let sortedDataArray = sortBy(score, data => data.date);
      const singleBenchmark = sortedDataArray.length === 1;
      benchmark.name = `Benchmark`;

      if (chart.kpiData.length === 0) {
        benchmark.description = generateLegendTitle(
          null,
          chart.category,
          0,
          true,
          industry ? industry.name : "",
          chart.benchmarkData.location
        );
      } else {
        benchmark.description = generateLegendTitle(
          chart.kpiData[0],
          chart.kpiData[0].kpiId.description,
          0,
          true,
          industry ? industry.name : ""
        );
      }

      benchmark.x = sortedDataArray.map(benchmark => benchmark.date);
      benchmark.y = sortedDataArray.map(benchmark => benchmark.value / 100);
      benchmark.type = "scatter";
      benchmark.line = benchmarkLineTypes[0];
      benchmark.marker = singleBenchmark
        ? plotlyMarkerTypes[3]
        : plotlyMarkerTypes[0];
      benchmark.xaxis = "x";
      benchmark.yaxis = "y";
    }

    const showEmptyLayout = checkNoDataLayoutValidity(kpi);
    if (showEmptyLayout) {
      layout = getEmptyGraphLayoutObject({
        l:30,
        r:30,
        t:30,
        b:30
      },16);
    }
    chart.layout = layout;
    chart.layout = layout;
    chart.benchmark = benchmark;
    chart.kpiForPlotly = kpi;
    chart.yAxisFormat = yAxisFormat;
    chart.yRange = yRange;
    chart.xMinDate = xMinDate;
    chart.xMaxDate = xMaxDate;
    chart.dtickFormat = dtickFormatVal;
    // console.log('process ch: ', chart)
    return chart;
  };

  render() {
    let { chart } = this.state;
    return chart && chart != null ? this.renderPlot() : null;
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
    reportCharts: state.reports.charts,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    onChartSelected: chart => dispatch(actionCreators.onChartSelected(chart)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
    updateReportCharts: dashboard =>
      dispatch(actionCreators.updateReportCharts(dashboard)),
  };
};

// export default LinkedCharts;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(DashboardChartPlot,axios)));
